import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchShouldSendCsatSurvey, fetchShouldSendCsatSurveyLegacy } from '../api/csatSurveyApi';
export const getShouldSendCsatSurvey = createAsyncThunk('chat/fetchShouldSendCsatSurvey', async ({
  threadId
}) => await fetchShouldSendCsatSurvey({
  threadId
}));

// Legacy Actions

export const getShouldSendCsatSurveyLegacy = createAsyncThunk('chat/fetchShouldSendCsatSurveyLegacy', async ({
  threadId
}) => await fetchShouldSendCsatSurveyLegacy(threadId));